

"use strict";

const TT_EOD = 0;
const TT_STRING = 1;
const TT_NUMBER = 2;
const TT_DATE = 3;
const TT_IDENTIFIER = 4;

const TT_COMMENT = 8;

const TT_PLUS = 10;
const TT_EQUALS = 11;
const TT_MINUS = 12;
const TT_MULTIPLY = 13;
const TT_DIVIDE = 14;
const TT_PERIOD = 15;
const TT_BACKSLASH = 16;
const TT_COLON = 17;
const TT_PERCENT = 18;
const TT_PIPE = 19;
const TT_EXCLAMATION = 20;
const TT_QUESTION = 21;
const TT_POUND = 22;
const TT_AMPERSAND = 23;
const TT_SEMI = 24;
const TT_COMMA = 25;
const TT_L_PAREN = 26;
const TT_R_PAREN = 27;
const TT_L_ANG = 28;
const TT_R_ANG = 29;
const TT_L_BRACE = 30;
const TT_R_BRACE = 31;
const TT_L_BRACKET = 32;
const TT_R_BRACKET = 33;

const TT_RW_WHEN = 111;
const TT_RW_THEN = 112;

const TT_RW_INCREASE = 121;
const TT_RW_DECREASE = 122;
const TT_RW_SET = 123;
const TT_RW_BY = 124;
const TT_RW_ON = 125
const TT_RW_AFTER = 126;
const TT_RW_UNTIL = 127;

const TT_RW_PROPOSED = 131;
const TT_RW_ACTUAL = 132;
const TT_RW_FINAL = 133;

const TT_RW_AND = 141;
const TT_RW_OR = 142;

const TT_RW_EQ = 131;
const TT_RW_NE = 132;
const TT_RW_LT = 133;
const TT_RW_LE = 134;
const TT_RW_GT = 135;
const TT_RW_GE = 136;

/*
    this.TT_RW_ADD = 115;
    this.TT_RW_SUB = 116;
    this.TT_RW_MUL = 117;
    this.TT_RW_DIV = 118;
*/    

module.exports.TT_EOD = TT_EOD;
module.exports.TT_STRING = TT_STRING;
module.exports.TT_NUMBER = TT_NUMBER;
module.exports.TT_DATE = TT_DATE;
module.exports.TT_IDENTIFIER = TT_IDENTIFIER;

module.exports.TT_COMMENT = TT_COMMENT;

module.exports.TT_PLUS = TT_PLUS;
module.exports.TT_EQUALS = TT_EQUALS;
module.exports.TT_MINUS = TT_MINUS;
module.exports.TT_MULTIPLY = TT_MULTIPLY;
module.exports.TT_DIVIDE = TT_DIVIDE;
module.exports.TT_PERIOD = TT_PERIOD;
module.exports.TT_BACKSLASH = TT_BACKSLASH;
module.exports.TT_COLON = TT_COLON;
module.exports.TT_PERCENT = TT_PERCENT;
module.exports.TT_PIPE = TT_PIPE;
module.exports.TT_EXCLAMATION = TT_EXCLAMATION;
module.exports.TT_QUESTION = TT_QUESTION;
module.exports.TT_POUND = TT_POUND;
module.exports.TT_AMPERSAND = TT_AMPERSAND;
module.exports.TT_SEMI = TT_SEMI;
module.exports.TT_COMMA = TT_COMMA;
module.exports.TT_L_PAREN = TT_L_PAREN;
module.exports.TT_R_PAREN = TT_R_PAREN;
module.exports.TT_L_ANG = TT_L_ANG;
module.exports.TT_R_ANG = TT_R_ANG;
module.exports.TT_L_BRACE = TT_L_BRACE;
module.exports.TT_R_BRACE = TT_R_BRACE;
module.exports.TT_L_BRACKET = TT_L_BRACKET;
module.exports.TT_R_BRACKET = TT_R_BRACKET;


module.exports.TT_RW_WHEN = TT_RW_WHEN;
module.exports.TT_RW_THEN = TT_RW_THEN;

module.exports.TT_RW_INCREASE = TT_RW_INCREASE;
module.exports.TT_RW_DECREASE = TT_RW_DECREASE;
module.exports.TT_RW_SET = TT_RW_SET;
module.exports.TT_RW_BY = TT_RW_BY;
module.exports.TT_RW_ON = TT_RW_ON
module.exports.TT_RW_AFTER = TT_RW_AFTER;
module.exports.TT_RW_UNTIL = TT_RW_UNTIL;

module.exports.TT_RW_PROPOSED = TT_RW_PROPOSED;
module.exports.TT_RW_ACTUAL = TT_RW_ACTUAL;
module.exports.TT_RW_FINAL = TT_RW_FINAL;


module.exports.TT_RW_AND = TT_RW_AND;
module.exports.TT_RW_OR = TT_RW_OR;

module.exports.TT_RW_EQ = TT_RW_EQ;
module.exports.TT_RW_NE = TT_RW_NE;
module.exports.TT_RW_LT = TT_RW_LT;
module.exports.TT_RW_LE = TT_RW_LE;
module.exports.TT_RW_GT = TT_RW_GT;
module.exports.TT_RW_GE = TT_RW_GE;


class Lexer {

  constructor() {

    this.pos = 0;
    this.buf = null;
    this.buflen = 0;


    // Operator table, mapping operator -> token name
    this.optable = {
      '+': TT_PLUS,
      '-': TT_MINUS,
      '*': TT_MULTIPLY,
      '/': TT_DIVIDE,
      '.': TT_PERIOD,
      '\\': TT_BACKSLASH,
      ':': TT_COLON,
      '%': TT_PERCENT,
      '|': TT_PIPE,
      '!': TT_EXCLAMATION,
      '?': TT_QUESTION,
      '#': TT_POUND,
      '&': TT_AMPERSAND,
      ';': TT_SEMI,
      ',': TT_COMMA,
      '(': TT_L_PAREN,
      ')': TT_R_PAREN,
      '<': TT_L_ANG,
      '>': TT_R_ANG,
      '{': TT_L_BRACE,
      '}': TT_R_BRACE,
      '[': TT_L_BRACKET,
      ']': TT_R_BRACKET,
      '=': TT_EQUALS
    };

    this.reservedWords = {
      'when': TT_RW_WHEN,
      'then': TT_RW_THEN,

      'inc': TT_RW_INCREASE,
      'increase': TT_RW_INCREASE,
      'dec': TT_RW_DECREASE,
      'decrease': TT_RW_DECREASE,
      'set': TT_RW_SET,
      'by': TT_RW_BY,
      'on': TT_RW_ON,
      'after': TT_RW_AFTER,
      'until': TT_RW_UNTIL,

      'proposed': TT_RW_PROPOSED,
      'actual': TT_RW_ACTUAL,
      'final': TT_RW_FINAL,


      'and': TT_RW_AND,
      'or': TT_RW_OR,
      'eq': TT_RW_EQ,
      'ne': TT_RW_NE,
      'gt': TT_RW_GT,
      'ge': TT_RW_GE,
      'lt': TT_RW_LT,
      'le': TT_RW_LE,
    }
  }


  // Initialize the Lexer's buffer. This resets the lexer's internal
  // state and subsequent tokens will be returned starting with the
  // beginning of the new buffer.
  input(buf) {
    this.pos = 0;
    this.buf = buf;

    this.buflen = buf.length;
  }


  // Get the next token from the current buffer. A token is an object with
  // the following properties:
  // - name: name of the pattern that this token matched (taken from rules).
  // - value: actual string value of the token.
  // - pos: offset in the current buffer where the token starts.
  //
  // If there are no more tokens in the buffer, returns null. In case of
  // an error throws Error.
  token() {
    this._skipnontokens();
    if (this.pos >= this.buflen) {
      return { type: TT_EOD, value: "", pos: 0 };
    }

    // The char at this.pos is part of a real token. Figure out which.
    var c = this.buf.charAt(this.pos);

    if (this._isalpha(c)) {
      return this._process_identifier();
    }
    else if (this._isdigit(c)) {
      return this._process_number();
    }
    else if (c === '#') {
      return this._process_date();
    }
    else if (c === '"') {
      return this._process_quote();
    }
    else if (c === '/' && this.buf.charAt(this.pos + 1) == '/' ) {
      // '/' is treated specially, because it starts a comment if followed by
      // another '/'. If not followed by another '/', it's the DIVIDE
      // operator.
      return this._process_comment();
    }
    else {
      // Look it up in the table of operators
      var op = this.optable[c];
      if (op !== undefined) {
        return { type: op, value: c, pos: this.pos++ };
      }
      else {
        throw Error('Token error at ' + this.pos);
      }
    }
  }


  _isnewline(c) {
    return c === '\r' || c === '\n';
  };


  _isdigit(c) {
    return c >= '0' && c <= '9';
  };


  _isalpha(c) {
    return (c >= 'a' && c <= 'z') ||
      (c >= 'A' && c <= 'Z') ||
      c === '_' || c === '$';
  };


  _isalphanum(c) {
    return (c >= 'a' && c <= 'z') ||
      (c >= 'A' && c <= 'Z') ||
      (c >= '0' && c <= '9') ||
      c === '_' || c === '$';
  };


  _process_number() {
    var endpos = this.pos + 1;
    while (endpos < this.buflen &&
      this._isdigit(this.buf.charAt(endpos))) {
      endpos++;
    }

    var tok =  this._createToken( TT_NUMBER );
    tok.value = this.buf.substring(this.pos, endpos),

    this.pos = endpos;
    return tok;
  };


  _process_date() {
    var endpos = this.pos + 1; // consume #

    endpos += 10; // consume yyyy-mm-dd

    var tok =  this._createToken( TT_DATE );
    tok.value = this.buf.substring(this.pos, endpos),

    this.pos = endpos;
    return tok;
  }


  _process_comment() {
    var endpos = this.pos + 2;
    // Skip until the end of the line
    var c = this.buf.charAt(this.pos + 2);

    while (endpos < this.buflen &&
      !this._isnewline(this.buf.charAt(endpos))) {
      endpos++;
    }

    var tok =  this._createToken( TT_COMMENT );
    tok.value = this.buf.substring(this.pos, endpos),

    this.pos = endpos + 1;
    return tok;
  };


  _process_identifier() {
    var endpos = this.pos + 1;
    while (endpos < this.buflen &&
      this._isalphanum(this.buf.charAt(endpos))) {
      endpos++;
    }

    var value = this.buf.substring(this.pos, endpos);
    var type = this.reservedWords[value.toLowerCase()];

    if (type === undefined) {
      type = TT_IDENTIFIER;
    }

    var tok =  this._createToken( type );
    tok.value = value,

    this.pos = endpos;
    return tok;
  };


  _process_quote() {
    // this.pos points at the opening quote. Find the ending quote.
    var end_index = this.buf.indexOf('"', this.pos + 1);

    if (end_index === -1) {
      throw 'Unterminated quote at ' + this.pos;
    } else {
      var tok =  this._createToken( TT_STRING );
      tok.value = this.buf.substring(this.pos+1, end_index),  // remove the quote chars

      this.pos = end_index + 1;
      return tok;
    }
  };


  _createToken( type ) {
    var tok = {
      type: type,
      value: "",
      pos: this.pos
    };

    return tok;
  }


  _skipnontokens() {
    while (this.pos < this.buflen) {
      var c = this.buf.charAt(this.pos);
      if (c === ' ' || c === '\t' || c === '\r' || c === '\n') {
        this.pos++;
      } else {
        break;
      }
    }
  };
}

module.exports.Lexer = Lexer;

/*
var lex = new Lexer();
lex.input("dog cat");
while (true) {
  var t = lex.token();
  if (t === null)
    break;

  console.log(t);
}
*/

